import axios from 'axios'
import Case from '../models/Case'
import DropOffLocation from '../models/DropOffLocation'

class CasesService {
  searchCase(id, license, state, releaseMethod, operations, recaptchaToken) {
    return axios
      .post('/driver-api/cases/search/results', {
        id,
        license,
        state,
        release_method: releaseMethod,
        operations,
        recaptcha_token: recaptchaToken,
      })
      .then(({ data }) => Case.fromJson(data.data))
  }

  loadBySlug(slug, releaseMethod) {
    return axios
      .get(`/driver-api/cases/${slug}?release-method=${releaseMethod}`)
      .then(({ data }) => Case.fromJson(data.data))
  }

  pay(
    caseSlug,
    firstName,
    lastName,
    addressLine,
    addressLine2,
    city,
    state,
    zipCode,
    country,
    phone,
    email,
    paymentMethodToken,
    releaseMethod,
    recaptchaToken
  ) {
    return axios
      .post(`/driver-api/cases/${caseSlug}/checkout`, {
        firstname: firstName,
        lastname: lastName,
        recaptcha_token: recaptchaToken,
        billing_address: {
          country,
          state,
          city,
          postalcode: zipCode,
          street: addressLine,
          street2: addressLine2,
        },
        phone,
        email,
        payment_method_token: paymentMethodToken,
        terms: true,
        release_method: releaseMethod,
      })
      .then(({ data }) => Case.fromJson(data.data))
  }

  checkoutCash(caseSlug, firstName, lastName, phone, email) {
    return axios
      .post(`/driver-api/cases/${caseSlug}/cash-payment-request`, {
        firstname: firstName,
        lastname: lastName,
        phone,
        email,
        terms: true,
      })
      .then(({ data }) => Case.fromJson(data.data))
  }

  getReleaseCode(caseSlug) {
    return axios.get(`/driver-api/boot-unlock-code/${caseSlug}`)
  }

  getDropOffLocations(operationId) {
    return axios
      .get(`/driver-api/storages?operation_id=${operationId}`)
      .then(({ data: dropOffLocations }) =>
        dropOffLocations.data.map((dropOffLocation) => DropOffLocation.fromJson(dropOffLocation))
      )
  }

  cancelCashPayment(caseSlug) {
    return axios
      .post(`/driver-api/cases/${caseSlug}/cancel-cash-payment-request`)
      .then(({ data }) => Case.fromJson(data.data))
  }

  loadCaseBills(caseSlug, selectedReleaseMethod) {
    return axios
      .post(`/driver-api/cases/${caseSlug}/bills`, {
        release_method: selectedReleaseMethod,
      })
      .then(({ data }) => Case.fromJson(data.data))
  }

  getSelfReleaseDescription = async (operation) => {
    try {
      const response = await axios.get(`/driver-api/business-rules/${operation.id}/self-release-description`)
      return { success: true, data: response.data }
    } catch (e) {
      let error = 'Unknown server error'
      
      if (axios.isAxiosError(e)) {
        if(e.response.status === 404){
          error = 'Self-release description not found (Please see email/SMS for details)'
        } else { 
          error = e.response.data.error
        }
      }
      return { success: false, error }
    }
  }
}

export default CasesService
